import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export const BasicModal = ({
  ContentModal,
  onClose,
  acceptButtonOnClick,
  isOpen,
  centered,
  size,
  backDrop,
  ...otherProps
}) => {
  const containerClasses = classNames('custom-modal', 'fade', { show: isOpen });
  const contentClasses = classNames('custom-modal-content', { centered });
  const dialogClasses = classNames('custom-modal-dialog', { [size]: size });

  return (
    <section
      className={containerClasses}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      tabIndex="-1"
    >
      <div onClick={backDrop ? onClose : undefined} className="modal-overlay" />
      <section className={contentClasses}>
        <div
          className={dialogClasses}
          style={{
            height: 'auto',
            overflow: 'auto',
          }}
        >
          {ContentModal ? (
            <ContentModal
              onClose={onClose}
              acceptButtonOnClick={acceptButtonOnClick}
              {...otherProps}
            />
          ) : (
            <p>No content defined for the modal.</p>
          )}
        </div>
      </section>
    </section>
  );
};

BasicModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  ContentModal: PropTypes.elementType.isRequired,
  onClose: PropTypes.func.isRequired,
  centered: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large', 'custom', 'small-confirm', 'auto']),
  backDrop: PropTypes.bool,
  acceptButtonOnClick: PropTypes.func,
};

BasicModal.defaultProps = {
  centered: false,
  size: 'medium',
  backDrop: true,
  acceptButtonOnClick: () => {},
};

export default BasicModal;
